import {CartOrderType, DownloadType, InvalidationJobType, JobType, ReprocessingJobType} from "../types/cart";
import AxiosServiceHandler from "./AxiosServiceHandler";
import {AppParametersType} from "../types/app";
import translations from "../translations";

class CartService extends AxiosServiceHandler {
  static parseCartOrder(cartOrder: CartOrderType) {
    return {
      ...cartOrder,
      items: cartOrder.items
        .map((cartOrderItem) => {
          const {
            // eslint-disable-next-line no-unused-vars
            doesItIntersectTheAoI,
            ...item
          } = cartOrderItem;
          return item;
        })
    }
  }

  static downloadProduct(appParameters: AppParametersType, download: DownloadType) {
    return new Promise((resolve) => resolve(true));
  }

  static submitJob(appParameters: AppParametersType, job: JobType | InvalidationJobType | ReprocessingJobType) {
    const url = `${process.env.REACT_APP_MAPIT}${process.env.REACT_APP_MAPIT_SUBMIT_JOB}`;
    return this.getInstance()
      .post(
        url,
        job
      );
  }

  static countJobs() {
    const url = `${process.env.REACT_APP_MAPIT}${process.env.REACT_APP_MAPIT_JOBS_COUNT}`;
    return this.getInstance()
      .get(
        url
      );
  }

  static countReprocessing() {
    const url = `${process.env.REACT_APP_MAPIT}${process.env.REACT_APP_MAPIT_REPROCESSING_COUNT}`;
    // return new Promise((resolve) => {
    //     resolve("3")
    // });
    return this.getInstance()
      .get(
        url
      );
  }

  static countDownloads() {
    const url = `${process.env.REACT_APP_MAPIT}${process.env.REACT_APP_MAPIT_DOWNLOADS_COUNT}`;
    return this.getInstance()
      .get(
        url
      );
  }
}

export default CartService;
